// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* QuestAnalyticsTab — Grid layout for quest analytics */

.quest-analytics {
  width: 100%;
}

.quest-analytics-kpis {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}

/* XP Brain Health Banner */
.quest-xp-banner {
  background: linear-gradient(135deg, #FFF9E6 0%, #FFF3CC 50%, #E6F2F5 100%);
  border: 1px solid #FFE799;
  border-radius: 14px;
  padding: 20px 24px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 20px;
}

.quest-xp-banner-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: linear-gradient(135deg, #D4AC0D, #FFCF33);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.quest-xp-banner-content {
  flex: 1;
}

.quest-xp-banner-label {
  font-family: 'Montserrat', sans-serif;
  font-size: 0.75rem;
  font-weight: 700;
  color: #A8890A;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.quest-xp-banner-value {
  font-family: 'Playfair Display', serif;
  font-size: 2rem;
  font-weight: 700;
  color: #504405;
  line-height: 1.2;
}

.quest-xp-banner-sub {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 0.85rem;
  color: #7C6608;
}

.quest-analytics-charts {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

@media (max-width: 900px) {
  .quest-analytics-charts {
    grid-template-columns: 1fr;
  }
}

.quest-chart-card {
  background: #fff;
  border: 1px solid #E5E7EB;
  border-radius: 14px;
  padding: 20px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.06);
}

.quest-chart-card--wide {
  grid-column: span 2;
}

@media (max-width: 900px) {
  .quest-chart-card--wide {
    grid-column: span 1;
  }
}

.quest-chart-title {
  font-family: 'Montserrat', sans-serif;
  font-size: 0.9rem;
  font-weight: 700;
  color: #A8890A;
  margin: 0 0 14px;
}

.quest-chart-canvas {
  position: relative;
  height: 280px;
}

.quest-chart-canvas--small {
  height: 240px;
}

/* Funnel visualization */
.quest-funnel {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 0;
}

.quest-funnel-step {
  display: flex;
  align-items: center;
  gap: 12px;
}

.quest-funnel-bar {
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  padding: 0 14px;
  font-family: 'Montserrat', sans-serif;
  font-size: 0.8rem;
  font-weight: 700;
  color: #fff;
  min-width: 60px;
  transition: width 0.4s ease;
}

.quest-funnel-label {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 0.85rem;
  color: #6C757D;
  min-width: 80px;
}

.quest-funnel-count {
  font-family: 'Montserrat', sans-serif;
  font-size: 0.85rem;
  font-weight: 600;
  color: #374151;
}

/* Time picker */
.quest-analytics-time-picker {
  display: flex;
  gap: 8px;
  margin-bottom: 20px;
}

/* Loading */
.quest-analytics-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  color: #6C757D;
  font-family: 'Montserrat', sans-serif;
  font-size: 0.9rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/content/QuestAnalyticsTab.css"],"names":[],"mappings":"AAAA,wDAAwD;;AAExD;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,0EAA0E;EAC1E,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,qCAAqC;EACrC,iBAAiB;AACnB","sourcesContent":["/* QuestAnalyticsTab — Grid layout for quest analytics */\n\n.quest-analytics {\n  width: 100%;\n}\n\n.quest-analytics-kpis {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n/* XP Brain Health Banner */\n.quest-xp-banner {\n  background: linear-gradient(135deg, #FFF9E6 0%, #FFF3CC 50%, #E6F2F5 100%);\n  border: 1px solid #FFE799;\n  border-radius: 14px;\n  padding: 20px 24px;\n  margin-bottom: 24px;\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.quest-xp-banner-icon {\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #D4AC0D, #FFCF33);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.quest-xp-banner-content {\n  flex: 1;\n}\n\n.quest-xp-banner-label {\n  font-family: 'Montserrat', sans-serif;\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: #A8890A;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n.quest-xp-banner-value {\n  font-family: 'Playfair Display', serif;\n  font-size: 2rem;\n  font-weight: 700;\n  color: #504405;\n  line-height: 1.2;\n}\n\n.quest-xp-banner-sub {\n  font-family: 'Source Sans Pro', sans-serif;\n  font-size: 0.85rem;\n  color: #7C6608;\n}\n\n.quest-analytics-charts {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n}\n\n@media (max-width: 900px) {\n  .quest-analytics-charts {\n    grid-template-columns: 1fr;\n  }\n}\n\n.quest-chart-card {\n  background: #fff;\n  border: 1px solid #E5E7EB;\n  border-radius: 14px;\n  padding: 20px;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.06);\n}\n\n.quest-chart-card--wide {\n  grid-column: span 2;\n}\n\n@media (max-width: 900px) {\n  .quest-chart-card--wide {\n    grid-column: span 1;\n  }\n}\n\n.quest-chart-title {\n  font-family: 'Montserrat', sans-serif;\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: #A8890A;\n  margin: 0 0 14px;\n}\n\n.quest-chart-canvas {\n  position: relative;\n  height: 280px;\n}\n\n.quest-chart-canvas--small {\n  height: 240px;\n}\n\n/* Funnel visualization */\n.quest-funnel {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px 0;\n}\n\n.quest-funnel-step {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.quest-funnel-bar {\n  height: 36px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  padding: 0 14px;\n  font-family: 'Montserrat', sans-serif;\n  font-size: 0.8rem;\n  font-weight: 700;\n  color: #fff;\n  min-width: 60px;\n  transition: width 0.4s ease;\n}\n\n.quest-funnel-label {\n  font-family: 'Source Sans Pro', sans-serif;\n  font-size: 0.85rem;\n  color: #6C757D;\n  min-width: 80px;\n}\n\n.quest-funnel-count {\n  font-family: 'Montserrat', sans-serif;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #374151;\n}\n\n/* Time picker */\n.quest-analytics-time-picker {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 20px;\n}\n\n/* Loading */\n.quest-analytics-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n  color: #6C757D;\n  font-family: 'Montserrat', sans-serif;\n  font-size: 0.9rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
